import Link from "next/link";
import React from "react";

const Footer: React.FC = () => (
  <footer className="flex flex-wrap items-center justify-center bg-black text-white w-full min-h-[43px] py-2 px-2 sm:py-[18.5px] sm:px-4">
    <div className="flex flex-wrap justify-center items-center gap-2 sm:gap-3 md:gap-9">
      <a
        href="https://www.tiktok.com/@chrisxlucas"
        target="_blank"
        rel="noopener noreferrer"
        className="text-white font-raleway text-xs sm:text-sm tracking-[0.1em] font-normal leading-none py-2 px-1 sm:py-3 sm:px-2 transition-colors hover:bg-light-grey"
      >
        TIKTOK
      </a>
      <a
        href="https://www.instagram.com/secondsenseco/"
        target="_blank"
        rel="noopener noreferrer"
        className="text-white font-raleway text-xs sm:text-sm tracking-[0.1em] font-normal leading-none py-2 px-1 sm:py-3 sm:px-2 transition-colors hover:bg-light-grey"
      >
        INSTAGRAM
      </a>
      <a
        href="mailto:hello@secondsense.co"
        className="text-white font-raleway text-xs sm:text-sm tracking-[0.1em] font-normal leading-none py-2 px-1 sm:py-3 sm:px-2 transition-colors hover:bg-light-grey"
      >
        CONTACT
      </a>
      <a
        href="https://secondsenseco.substack.com"
        target="_blank"
        rel="noopener noreferrer"
        className="text-white font-raleway text-xs sm:text-sm tracking-[0.1em] font-normal leading-none py-2 px-1 sm:py-3 sm:px-2 transition-colors hover:bg-light-grey"
      >
        NEWSLETTER
      </a>
      <a
        href="https://www.trustpilot.com/review/secondsense.co"
        target="_blank"
        rel="noopener noreferrer"
        className="text-white font-raleway text-xs sm:text-sm tracking-[0.1em] font-normal leading-none py-2 px-1 sm:py-3 sm:px-2 transition-colors hover:bg-light-grey"
      >
        TRUSTPILOT
      </a>
      <Link
        href="/terms"
        className="text-white font-raleway text-xs sm:text-sm tracking-[0.1em] font-normal leading-none py-2 px-1 sm:py-3 sm:px-2 transition-colors hover:bg-light-grey"
      >
        TERMS OF USE
      </Link>
      <Link
        href="/privacy"
        className="text-white font-raleway text-xs sm:text-sm tracking-[0.1em] font-normal leading-none py-2 px-1 sm:py-3 sm:px-2 transition-colors hover:bg-light-grey"
      >
        PRIVACY POLICY
      </Link>
      <span className="text-xs sm:text-sm font-raleway tracking-[0.1em] font-normal leading-none text-center py-1 px-2 sm:py-2 sm:px-6">
        © 2025 SECONDSENSE Co. All rights reserved.
      </span>
    </div>
  </footer>
);

export default Footer;
